module.exports = __webpack_public_path__ + "media/images/app/products/index/types/necklaces-mobile-0f1193bbff7f3c543bdd2743a68224a5.webp";